import { render, staticRenderFns } from "./correspondence.vue?vue&type=template&id=19c6e773&scoped=true&lang=pug&"
import script from "./correspondence.vue?vue&type=script&lang=js&"
export * from "./correspondence.vue?vue&type=script&lang=js&"
import style0 from "./correspondence.vue?vue&type=style&index=0&id=19c6e773&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19c6e773",
  null
  
)

export default component.exports